/**
 * APP_ID keys mirror git branch names for 1:1 mapping with CI builds.
 */

import { resolveAppHostname } from './appOrigin.js';
import { usesProductionBackend } from './environmentHostnames.js';

const HOSTNAMES = {
  master: 'meetings.sangoma.com',
  preview: 'preview.meetings.sangoma.com',
  staging: 'staging.meetings.sangoma.com',
};


export const APP_DOMAIN = '8x8.vc';

export const APP_IDS = {
  master: 'vpaas-magic-cookie-e3ac3df372b44064b0a0320c5ade63b0',
  staging: 'vpaas-magic-cookie-e338d0c9ff574d16b0bd2d3be859bfdf',
  develop: 'vpaas-magic-cookie-1d4913fd161349769c65c9203f2cbc3e',
};

/**
 * @param {string} hostname
 * @returns {string} The APP_ID for the given environment
 */
export function getAppIdForHostname(hostname) {
  if (
    hostname === HOSTNAMES.master ||
    hostname === HOSTNAMES.preview ||
    usesProductionBackend(hostname)
  ) {
    return APP_IDS.master;
  }

  if (hostname === HOSTNAMES.staging ) {
    return APP_IDS.staging;
  }

  return APP_IDS.develop;
}

/**
 * @returns {string} The APP_ID for the current environment
 *
 * SM-1243: derived from the origin the NG Meet bundle was served from. Reading
 * `window.location.hostname` returns the TeamHub host in MF mode, which matches
 * no entry here and hands production the develop app id.
 */
export function getCurrentAppId() {
  const hostname = resolveAppHostname();
  if (hostname) {
    return getAppIdForHostname(hostname);
  }

  return APP_IDS.develop;
}
